import axios from 'axios'

async function start_assessment(dispatch,data,assessment,token,setOpen,setMessage,setAss,setRecentQuestion,setSubmiting,setHasStarted,setQuestion,setQuestionType,setIsPaused,setDiv,setTime,setSe_time,isAuth,addData){

    setSubmiting(true)

    const URL = `${process.env.REACT_APP_SERVER_AUTH_URL}start-assessment/`

    const testStart = await axios.post(URL,data,{
        headers:{
                "Content-Type":"application/json",
                "Authorization":`Bear ${token}`
            }
    }).catch(err=>{console.log(err)})

    if (testStart?.status == 200 && testStart?.data.success == true) {

    setSubmiting(false)
    setQuestion(testStart?.data?.question?.question)
    setAss({
        ...testStart?.data?.question,
        ...testStart?.data?.section
    })
    setQuestionType(testStart?.data?.question?.question_type)
    setHasStarted(true)
    setIsPaused(false)
    setTime(assessment?.time*60)
    setSe_time(testStart?.data?.section.duration*60)
    setDiv((testStart?.data?.section.duration*60)/assessment.sections[data?.section]?.questions.length) 
    // setRecentQuestion(prev=>prev+1)
    // addData({
    //     title:"Assessment passed",
    //     isCreated:false,
    //     level:assessment?.level,
    //     language:assessment?.language,
    //     questions:assessment?.questions,
    //     id:assessment?.id,
    //     from:assessment?.name,
    //     start_moment:assessment?.start_moment,
    //     start_date:assessment?.start_date,
    //     time:assessment?.time,
    //     description:assessment?.description
    // })

    }else{
        setSubmiting(false)
        setHasStarted(false)
        setMessage(testStart?.data?.message)
        setOpen(true)
    }
}

export default start_assessment